var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.webLoaded)?_c('div',{staticClass:"jumbotron no_space dmbs-container"},[_c('Body')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }